
import React from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import useTranslation from '../../../Hooks/UseTranslation'
import { useProgrammation } from '../../../Hooks/UseProgrammation'
import { updateTaskFieldAction } from '../../../Redux/Actions/ProgrammationManagerActions'
import { updateTaskField } from '../../../Services/ProgrammationManagerService'

import Textarea from '../components/Textarea'

const TaskDescription = () => {

  const dispatch = useDispatch()

  const { t } = useTranslation()

  const { itemOpened, setEditingItem } = useProgrammation()

  const handleChangeDescription = async (newDescription: string) => {

    const [error] = await updateTaskField(itemOpened._id, 'description', newDescription);

    if (error) {
      return false;
    }

    await dispatch(updateTaskFieldAction(itemOpened._id, 'description', newDescription))

    setEditingItem(false)
  }

  return (
    <Form.Group>
      <Form.Label>
        {t('PROGRAMMATION_MANAGER:DescriptionLabel')}
      </Form.Label>
      <Textarea
        value={itemOpened.description}
        onChange={handleChangeDescription}
        onStartEditing={() => setEditingItem(true)}
        placeholder="Ingresa la descripción"
        delay={500}
      />
    </Form.Group>
  )
}

export default TaskDescription
